<script>
  let projects = [
    {
      name: 'Developer Dashboard',
      todos: ['Set up Svelte project', 'Create initial layout', 'Add project data', 'Style the dashboard'],
      dependencies: ['Svelte', 'Vite'],
      collaborators: ['AI Assistant'],
      techStack: ['Svelte', 'HTML', 'CSS', 'JavaScript']
    },
    {
      name: 'E-commerce Website',
      todos: ['Design homepage', 'Implement product catalog', 'Set up shopping cart', 'Integrate payment gateway'],
      dependencies: ['React', 'Node.js', 'Express', 'MongoDB'],
      collaborators: ['John Doe', 'Jane Smith'],
      techStack: ['React', 'Node.js', 'Express', 'MongoDB']
    }
  ];
</script>

<main>
  <h1>Developer Dashboard</h1>

  {#each projects as project}
    <div class="project">
      <h2>{project.name}</h2>

      <div class="details">
        <div>
          <h3>TODOs</h3>
          <ul>
            {#each project.todos as todo}
              <li>{todo}</li>
            {/each}
          </ul>
        </div>

        <div>
          <h3>Dependencies</h3>
          <ul>
            {#each project.dependencies as dependency}
              <li>{dependency}</li>
            {/each}
          </ul>
        </div>

        <div>
          <h3>Collaborators</h3>
          <ul>
            {#each project.collaborators as collaborator}
              <li>{collaborator}</li>
            {/each}
          </ul>
        </div>

        <div>
          <h3>Tech Stack</h3>
          <ul>
            {#each project.techStack as tech}
              <li>{tech}</li>
            {/each}
          </ul>
        </div>
      </div>
    </div>
  {/each}
</main>

<style>
  main {
    padding: 1em;
  }

  h1 {
    text-align: center;
    color: #ff3e00;
  }

  .project {
    border: 1px solid #ccc;
    border-radius: 5px;
    margin-bottom: 1em;
    padding: 1em;
  }

  h2 {
    margin-top: 0;
  }

  .details {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 1em;
  }

  h3 {
    margin-top: 0;
  }

  ul {
    list-style-type: none;
    padding: 0;
  }

  li {
    margin-bottom: 0.5em;
  }
</style>